import { Component, OnInit } from '@angular/core';
import {Observable} from "rxjs/index";
import {AuthService} from '../shared/security/auth.service';
import {ErrorService} from "../shared/model/error.service";
import {Error} from "../shared/model/error";
import {FieldsService} from "../shared/model/fields.service";
import {Club} from "../shared/model/club";
import {Field} from "../shared/model/field";
import {Cpu} from "../shared/model/cpu";
import {forEach} from "@angular/router/src/utils/collection";

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {

  errors$: Observable<Error[]>;
  clubIdForUser: string;
  field: Field;
  cpu: Cpu;
  showError: boolean = false;

  constructor(private authService: AuthService, private errorService: ErrorService, private fieldService: FieldsService) { }

  ngOnInit() {
    this.clubIdForUser = this.authService.getClubIdForUser();
    this.errors$ = this.errorService.findErrorsForClubId(this.clubIdForUser);
  }

  getFieldDetails(fieldId: string, cpuId: string) {
    //console.log("fieldId: " + fieldId);
    //console.log("cpuId: " + cpuId);
    this.fieldService.findFieldForClubIdAndFieldId(this.clubIdForUser, fieldId).forEach(f => {
        this.field = f;
        f.cpus.forEach(c => {
          if(c.$key === cpuId) {
            this.cpu = c;
          }
        });
    });
    setTimeout(() => this.showError = true, 500);
  }

  closeError(val: boolean) {
    this.showError = false;
  }

}
